import { schema } from 'normalizr';
import assetSchema from './asset_schema';

export default new schema.Entity('catalog_entries', {
  assets: [assetSchema],
});
